import { useSupportService } from '@/layout/appWrapper/ServiceProvider';
import { useLocalization } from '@/services/localizationService';
import { contactFormLoading } from '@/stores/contactFormStore';
import Spinner from '@/ui/content/Spinner';
import { useRecoilValue } from 'recoil';

const disabledStyle = 'bg-gray-400 cursor-not-allowed';
const enabledStyle = 'bg-black cursor-pointer';

type StyleButtonOptions = {
  disabled: boolean;
};
function styleButton({ disabled }: StyleButtonOptions) {
  const base =
    'btn btn--large py-4 rounded-full text-white SB18 border-none w-full ';
  if (disabled) return base + disabledStyle;
  return base + enabledStyle;
}

function InlineSpinner() {
  return (
    <span className="ml-4">
      <Spinner inline size={18} color="white" />
    </span>
  );
}

export default function SendButton() {
  const { useIsRequestDataComplete, useSendCustomerSupportRequest } =
    useSupportService();
  const isRequestDataCompleted = useIsRequestDataComplete();
  const isLoading = useRecoilValue(contactFormLoading);
  const sendRequest = useSendCustomerSupportRequest();
  const { t, data } = useLocalization();
  return (
    <button
      type="submit"
      className={styleButton({
        disabled: !isRequestDataCompleted,
      })}
      onClick={sendRequest}
    >
      {t(data.support.sendRequest)}
      {isLoading && <InlineSpinner />}
    </button>
  );
}
